module.exports = __webpack_public_path__ + "static/img/c_bg.3191668.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c_bg.png
// module id = eauN
// module chunks = 1